import { RawMessagesViewer } from '../components'
import { useAccountContext } from '../contexts'
import { Layout } from '../layouts/Layout'

export function RawMessagesPage() {
  const { selectedDevice } = useAccountContext()

  return (
    <Layout>
      <RawMessagesViewer sigfoxId={selectedDevice} />
    </Layout>
  )
}
